/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs */

const es_user_profile_api_keys_toasts_delete_success_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave API fue eliminada correctamente.`)
};

const en_user_profile_api_keys_toasts_delete_success_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your API key has been removed.`)
};

/**
* | output |
* | --- |
* | "Your API key has been removed." |
*
* @param {User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_delete_success_description = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Delete_Success_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_delete_success_description(inputs)
	return en_user_profile_api_keys_toasts_delete_success_description(inputs)
});
export { user_profile_api_keys_toasts_delete_success_description as "user.profile.api_keys.toasts.delete.success_description" }